import { render, staticRenderFns } from "./VideoConfig.vue?vue&type=template&id=45cce714&scoped=true"
import script from "./VideoConfig.vue?vue&type=script&lang=js"
export * from "./VideoConfig.vue?vue&type=script&lang=js"
import style0 from "./VideoConfig.vue?vue&type=style&index=0&id=45cce714&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cce714",
  null
  
)

export default component.exports